<script>
import {mapGetters, mapActions} from 'vuex'
import pf from '../../services/pf'
import stepsMixin from '../../mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	components: {
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../../components/simulator/pf/PfModal'),
	},
	data() {
		return {
			modalNewAnalysis: {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			},
			history: [],
		}
	},
	computed: {
		...mapGetters({
			pfSearch: 'pfClients/search',
			userId: 'auth/userId',
			getClientById: 'pfClients/getById',
			showHelpPF: 'pfStatus/showHelp'

		})
	},
	methods: {
		async getHistory() {
			let vm = this
			let history = await pf.findAll({user_id: vm.userId})
			history = history.map(h => {
				h.client = vm.getClientById(h.client_id)
				return h
			})

			vm.$set(vm, 'history', history)
		},
		async createNewAnalysis() {
			this.hiddenSteps()
			let client = JSON.stringify(this.modalNewAnalysis.selectedClient)
				client = JSON.parse(client)
				client.user_id = this.userId
			try {
				let analysis = await this.pfSave(client)
				this.$router.push({name: 'pf-details', params: {id: analysis._id}})
			} catch (err) {
				console.log(err)
			}
		},
		resetNewAnalysis() {
			this.$set(this, 'modalNewAnalysis', {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			})
		},
		openNewAnalysis() {
			let vm = this
			this.$refs['newAnalysisModal'].open(null, function () {
				vm.hiddenSteps()
			})
			this.showSteps('pfNewAnalysis')
		},
		submitSearch() {
			this.$set(this.modalNewAnalysis, 'selectedClient', null)
			this.$set(this.modalNewAnalysis, 'results', [])
			let results = JSON.stringify(this.pfSearch(this.modalNewAnalysis.query))
				results = JSON.parse(results)
			this.$set(this.modalNewAnalysis, 'results', results)

			if(results.length) {
				this.goToStep('pfNewAnalysis', 5)
			} else {
				this.goToStep('pfNewAnalysis', 10)
			}
		},
		selectClient(c) {
			c = JSON.stringify(c)
			c = JSON.parse(c)
			this.$set(this.modalNewAnalysis, 'selectedClient', c)
			this.goToStep('pfNewAnalysis', 7)
		},
		openItem(event) {
			let target = event.currentTarget

			target.classList.add('open')
			this.goToStep('pfNewAnalysis', 8)
		},
		setClient(client) {
			let last = document.querySelector('.text.select')
			if(last) {
				last.classList.remove('select')
			}
			let target = event.currentTarget
			target.classList.add('select')

			this.$set(this.modalNewAnalysis, 'clientAnalysis', client)
			this.goToStep('pfNewAnalysis', 9)

		},
		goToDetails(id) {
			this.$router.push({name: 'pf-details', params: {id: id}})
		},
		getCompletion(analysis) {
			let keys = Object.keys(analysis)
			let total = 0
			keys.forEach((k, index)=> {
				total += Number(analysis[k].avance)
			})

			if(keys.length) {
				return (total / keys.length).toFixed(2)
			}

			return 0
		},
		...mapActions({
			pfSave: 'pfAnalysis/savePf'
		})
	},

	mounted() {
		this.getHistory()
		this.showSteps('pfIntro')
	}
}
</script>
<template>
	<div class="container">
		<pf-modal ref="newAnalysisModal" :show-close="true" title="Nuevo análisis" class="pf-modal--lg" @closed="resetNewAnalysis" data-v-step="pf_na_0"> 
			<div class="p-3" style="min-height: 800px" >
				<form @submit.prevent="submitSearch">
					<div class="d-flex flex-wrap border-bottom">
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Ámbito</span>
								<select class="pf-control__input pf-control--block" disabled>
									<option value="">México</option>
								</select>
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Búsqueda por</span>
								<select class="pf-control__input pf-control--block" data-v-step="pf_na_1">
									<option value="">--Seleccione--</option>
									<option value="Supragrupo">Supragrupo</option>
									<option value="Grupo">Grupo</option>
									<option value="Subgrupo">Subgrupo</option>
									<option value="Cliente/Filial">Cliente/Filial</option>
								</select>
							</label>
						</div>
						<div class="col-12 col-lg-3" >
							<label class="pf-control" v-if="modalNewAnalysis.type !== 'Lite'">	
								<span class="pf-control__label">Banco</span>
								<select class="pf-control__input pf-control--block" disabled>
									<option value="">9016</option>
								</select>
							</label>
						</div>
						<div class="col-12 col-lg-3"></div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label" >Tipo plantilla PF</span>
								<select class="pf-control__input pf-control--block" v-model="modalNewAnalysis.type" data-v-step="pf_na_2">
									<option value="">--Seleccione--</option>
									<option value="Corporativa">Corporativa</option>
									<option value="Promotor">Promotor</option>
									<option value="Lite">Lite</option>
								</select>
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control"  v-if="modalNewAnalysis.type !== 'Lite'">	
								<span class="pf-control__label">CIF</span>
								<input type="text" class="pf-control__input pf-control--block">
							</label>
							<label class="pf-control" v-else>	
								<span class="pf-control__label">N° Cliente/Grupo</span>
								<input type="text" class="pf-control__input pf-control--block">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Nombre</span>
								<input type="text" class="pf-control__input pf-control--block" v-model="modalNewAnalysis.query" data-v-step="pf_na_3">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<button type="submit" class="btn btn-sm btn-primary" style="font-weight: 300" data-v-step="pf_na_4">Buscar</button>
						</div>
					</div>
				
				</form>

					<div class="pt-3" v-if="modalNewAnalysis.results.length && !modalNewAnalysis.selectedClient"> 
						<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="mr-3">Buscar:</span><input type="text" class="border-none">
								</div>
							</div>
						</div>
						<div>
							<table class="table table-borderless w-100">
								<tbody style="font-size: 0.8em" class="text-center">
									<tr data-v-step="pf_na_5">
										<th class="pf-section-gradient py-2" style="width: 2rem"></th>
										<th class="pf-section-gradient py-2 text-left">NOMBRE</th>
										<th class="pf-section-gradient py-2 text-left">CODIGO/CIF</th>
									</tr>
									<tr class="pointer" v-for="(cliente, index) in modalNewAnalysis.results" :key="`cliente_${cliente.id}_${index}`" @click="selectClient(cliente)">
										<td class="px-1" data-v-step="pf_na_6">
											<span class="icon-group text-primary" style="font-size: 1.3rem"></span>
										</td>
										<td class="text-left">
											{{cliente.nombre}}
										</td>
										<td class="text-left">
											{{cliente.cif}}
										</td>
									</tr>
								</tbody>
							
							</table>

							<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="px-1 small">Primero</span>
									<span class="px-1 small">Anterior</span>
									<span class="px-1 small">1</span>
									<span class="px-1 small">Siguiente</span>
									<span class="px-1 small">Último</span>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div v-if="modalNewAnalysis.selectedClient" class="diagram" style="min-height: 500px">
						<div class="diagram__item">
							<div class="diagram__title diagram__title--top" @click.prevent="openItem">
								<span class="icon-group text-primary" style="font-size: 1.3rem" data-v-step="pf_na_7"></span> <span class="text" @click.stop="setClient(modalNewAnalysis.selectedClient)" data-v-step="pf_na_8"><b>{{modalNewAnalysis.selectedClient.nombre}}</b></span> 
							</div>
							<div class="diagram__item">
								<div class="diagram__title diagram__title--top" @click.prevent="openItem">
									<span class="icon-plus-symbol-button text-primary"></span> <b>Ver todos los participes</b>
								</div>
								<div class="diagram__item" v-for="(filial, index) in modalNewAnalysis.selectedClient.hijos" :key="`filial_${filial.id}_${index}`">
									<div class="diagram__title">
										<span class="icon-user text-primary"></span> <span class="text" @click.stop="setClient(filial)">{{filial.nombre}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="modalNewAnalysis.clientAnalysis" class="mt-5 py-3 border-top" style="color: #000; font-size: 0.8em">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6">
								Seleccionado: <b>{{modalNewAnalysis.clientAnalysis.nombre}}</b>
							</div>
							<div class="col-12 col-md-3">
								Nivel: <b>{{modalNewAnalysis.clientAnalysis.tipo === 'Grupo' ? 'Grupo' : 'Partícipe'}}</b>
							</div>
							<div class="col-12 col-md-3">
								Entidad: <b>{{modalNewAnalysis.clientAnalysis.entidad}}</b>
							</div>
						</div>

						<div class="d-flex justify-content-center flex-wrap mt-4">
							<div class="col-6 col-md-3">
								<button class="btn btn-primary btn-block rounded w-100" style="font-weight: 300;" @click="createNewAnalysis"  data-v-step="pf_na_9">
									Crear Nuevo PF <br> (Partícipe)
								</button>
							</div>
							<div class="col-6 col-md-3">
								<button class="btn btn-primary btn-block rounded w-100" style="font-weight: 300;">
									Renovar PF <br> (Partícipe)
								</button>
							</div>
							<div class="col-6 col-md-3">
								<button class="btn btn-primary btn-block rounded w-100" style="font-weight: 300;">
									Crear PF Operación PF <br> (Partícipe)
								</button>
							</div>
						</div>
					</div>
			</div>
		</pf-modal>
		<h4 class="text-right text-primary m-0 font-weight-light mb-2" style="font-size: 1.3rem"> <span class="icon-home"  data-v-step="pf_1"></span> Programa Financiero Digital</h4>
		<h4 class="m-0 font-weight-light mb-2"  style="font-size: 1.3rem">Mis grupos y clientes</h4>

		<div class="pf-section-gradient mb-2">
			<div class="d-flex">
				<div class="ml-auto d-flex align-items-end">
					<input type="text" class="border-none" data-v-step="pf_11"> <span class="px-2">Buscar</span> <button class="btn btn-sm btn-primary"><span class="icon-search"></span></button>
				</div>
			</div>
		</div>
		<div class="pf-section p-0">
			<!-- <pre>{{history}}</pre> -->
			<table class="table w-100" >
				<thead style="font-size: 0.8em" class="text-center"  data-v-step="pf_2">
					<tr >
						<th>NOMBRE</th>
						<th>TÍTULO</th>
						<th>TIPO</th>
						<th>CIF</th>
						<th>ÚLT. CAMBIO</th>
						<th>ESTADO</th>
						<th>PLANTILLA</th>
						<th ></th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="showHelpPF">
						<td data-v-step="pf_3">
							<span class="icon-user text-primary"></span> Grupo de Ejemplo
						</td>
						<td>
							Partícipe
						</td>
						<td>
							Renovación
						</td>
						<td>
							cif000001
						</td>
						<td data-v-step="pf_4">
							{{'07-02-2021' | moment("DD/MM/YYYY")}}
						</td>
						<td data-v-step="pf_5">
							En curso - iniciado
						</td>
						<td>
							Lite
						</td>
						<td data-v-step="pf_6">
							<div class="text-nowrap d-flex align-items-center">
								<div  class="table-completion mr-2">
									<div class="table-completion__fill" :style="{width: '90%'}"></div>
								</div> 90%
							</div>
						</td>
						<td>
							<div class="d-flex">
								<button class="table-btn" data-v-step="pf_7"><span class="icon-eye"></span></button>
								<button class="table-btn" data-v-step="pf_8"><span class="icon-pen"></span></button>
								<button class="table-btn" data-v-step="pf_9"><span class="icon-blank-page"><span class="path1"></span><span class="path2"></span></span></button>
								<button class="table-btn" data-v-step="pf_10"><span class="icon-trash"></span></button>
							</div>
						</td>
					</tr>
					<tr v-for="(a, index) in history" :key="`analysis_cliente_${index}`">
						<td>
							<span class="icon-user text-primary"></span> {{a.client.datos.nombre}}
						</td>
						<td>
							Partícipe
						</td>
						<td>
							Renovación
						</td>
						<td>
							{{a.client.datos.cif}}
						</td>
						<td>
							{{a.updatedAt | moment("DD/MM/YYYY")}}
						</td>
						<td>
							{{a.status}}
						</td>
						<td>
							Lite
						</td>
						<td>
							<div class="text-nowrap d-flex align-items-center">
								<div  class="table-completion mr-2">
									<div class="table-completion__fill" :style="{width: getCompletion(a.analysis) + '%'}"></div>
								</div> {{getCompletion(a.analysis)}}%
							</div>
						</td>
						<td>
							<div class="d-flex">
								<button class="table-btn"><span class="icon-eye"></span></button>
								<button class="table-btn" @click="goToDetails(a._id)"><span class="icon-pen"></span></button>
								<button class="table-btn"><span class="icon-blank-page"><span class="path1"></span><span class="path2"></span></span></button>
								<button class="table-btn"><span class="icon-trash"></span></button>
							</div>
						</td>
					</tr>
					
				</tbody>
			</table>
		</div>
		<div class="pf-section-gradient mb-2">
			<div class="d-flex">
				<div class="ml-auto d-flex align-items-end">
					<span class="px-2 small">Primero</span>
					<span class="px-2 small">Anterior</span>
					<span class="px-2 small">Siguiente</span>
					<span class="px-2 small">Último</span>
				</div>
			</div>
		</div>
		<div class="d-flex mb-2">
			<div class="ml-auto d-flex">
				<button class="btn btn-sm btn-primary"> <span class="icon-trash"></span> Elementos Eliminados</button>
				<button class="btn btn-sm btn-primary ml-2" @click="openNewAnalysis" data-v-step="pf_12"> <span class="icon-add"></span> Nuevo análisis</button>
			</div>
		</div>

		<div class="pf-section p-2 d-flex rounded">
			<div class="d-flex align-items-center">
				<span class="px-2 small">Contactos</span>|
				<span class="px-2 small">Docuementación</span>|
				<span class="px-2 small">FAQs</span>|
				<span class="px-2 small">v9.0</span>
			</div>
		</div>
	</div>
</template>